import { flatMap } from 'lodash-es';

/**
 * Inserts a separator between each element of an array.
 * Unlike `Array.join`, this works with ReactNode or any type instead of converting to string.
 */
export default function intersperse<T>(arr: T[], separator: T) {
  const notEmptyArr = arr.filter(Boolean);
  return flatMap(notEmptyArr, (item, idx) => (idx < notEmptyArr.length - 1 ? [item, separator] : [item]));
}
